import { Button, Separator, Input } from '@/components/atoms';
import { FormField } from '@/components/molecules';
import GoogleIcon from '@/assets/svg/google-icon.svg?react';
import { useRequestOTP } from '@/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { passwordResetSchema } from '@/validation-schema';
import { useOutletContext } from 'react-router';
import type { Dispatch, SetStateAction } from 'react';
import type { OutletContext } from '@/components/layouts';

interface PasswordResetFormProps {
  setIdentifier: Dispatch<SetStateAction<string>>;
}

export const PasswordResetForm = ({
  setIdentifier,
}: PasswordResetFormProps) => {
  const { incrementStep } = useOutletContext<OutletContext>();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(passwordResetSchema),
    mode: 'onChange',
  });

  const { mutate: request, isPending: isRequestPending } = useRequestOTP(() =>
    incrementStep(2)
  );

  const reset = ({ email }: { email: string }) => {
    setIdentifier(email);
    request({
      identifier: email,
      type: 'forgot-password',
      channel: 'email',
    });
  };

  const continueWithGoogle = () => {};

  return (
    <>
      <form
        onSubmit={handleSubmit(reset)}
        className="grid grid-cols-2 gap-6 px-4 md:px-6 lg:px-8"
      >
        <FormField
          label="Email"
          className="col-span-2"
          error={errors.email?.message}
        >
          <Input
            placeholder="example@gosellyt.com"
            type="email"
            {...register('email')}
          />
        </FormField>
        <Button
          className="col-span-2"
          label="Continue"
          size="lg"
          type="submit"
          isLoading={isRequestPending}
          disabled={!isValid}
        />
      </form>
      <div className="grid grid-cols-2 gap-6 px-4 md:px-6 lg:px-8">
        <div className="flex items-center gap-4 relative col-span-2 px-4 md:px-6 lg:px-8">
          <Separator />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="py-1 px-6 text-center bg-white">or</span>
          </div>
        </div>
        <Button
          onClick={continueWithGoogle}
          className="col-span-2"
          variant="outline"
          size="lg"
        >
          <GoogleIcon /> Continue with Google
        </Button>
      </div>
    </>
  );
};
